import { isNullOrEmpty } from "@smpu-web/utils/utils";

export const getQueryStringWithParam = (param: string) => {
    let search = window.location.search;
    let params = new URLSearchParams(search);

    return params.get(param)
}

export const isMimCall = () => {
    return !isNullOrEmpty(getQueryStringWithParam("mim")) && !isNullOrEmpty(getQueryStringWithParam("ts"))
}

export const setSelectedPosType = (posType: string) => {
    switch (posType) {
        case "1":
            return "MASAUSTU";

        case "2":
            return "YAZARKASA";

        case "3":
            return "MOBIL";

        case "4":
            return "MPOS";
            
        default:
            return null;
    }
}
